import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { BillService } from 'src/app/services/bill.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-print-ticket',
  templateUrl: './print-ticket.component.html',
  styleUrls: ['./print-ticket.component.scss'],
})
export class PrintTicketComponent implements OnInit {


  @ViewChild('printContent', { read: ElementRef }) printSection?: ElementRef;


  channelLogo?: string;
  channelName: string = 'MallGo';
  @Input() contest: any;
  @Input() tickets: any;
  userInformation: any;

  constructor(private configService: ConfigService, private billService: BillService, private modalCtrl: ModalController) {
    this.channelName = this.configService.mall?.name || 'MallGo';
    if (this.configService.mall?.logo) {
      this.channelLogo = this.configService.mall?.logo;
    } else if (this.configService.mall?.customer.logo) {
      this.channelLogo = this.configService.mall?.customer.logo;
    }
  }

  ngOnInit() {
    console.debug('Contest', this.contest);
    console.debug('Ticket', this.tickets);
    this.loadUserInformation();
  }

  loadUserInformation() {
    if (!this.tickets || this.tickets.length == 0) return;
    let userId = this.tickets[0].user_id;
    console.debug('User ID', userId);
    this.billService.getProfileInfoById(userId).subscribe((response) => {
      this.userInformation = response;
      console.debug('User Information', this.userInformation);
    });
  }

  print() {
    window.print();
  }


  customPrint() {
    if (!this.printSection) return;
    console.debug('Print Section', this.printSection);

    const printContent = this.printSection.nativeElement;
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    if (!WindowPrt) return;

    console.debug('Print Content', printContent.children);

    let pageTickets = printContent.children;
    console.debug('Page Tickets', pageTickets);

    console.debug(printContent.innerHTML);
    WindowPrt.document.write(`
      <style>
        .logo-image {
          max-width: 35vh;
          max-height: 20vh;
          margin-left: auto;
          margin-right: auto;
          margin-bottom: 5vh;
        }
    
        #print-button {
          display: none !important;
        }
    
        .ticket-content {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 80vh;
          max-height: 90vh;
          page-break-after: always;
          text-align: center;
          padding: 1vw 1vh;
          font-family: Arial, sans-serif;
        }
    
        h1.ion-text-center {
          font-size: 4.5vh;
          font-weight: bold;
          margin: 0;
          text-transform: uppercase;
        }
    
        h2.ion-text-center {
          font-size: 3vh;
          font-weight: bold;
          margin: 2vh 0;
          text-transform: uppercase;
        }
    
        p.ion-text-center {
          font-size: 2vh;
          margin: 1vh 0;
          line-height: 1.4;
        }
    
        p.ion-text-center b {
          font-weight: bold;
          font-size: 2vh;
        }
    
        .ion-margin-top p.ion-text-center {
          font-size: 2vh;
          font-weight: bold;
          text-transform: uppercase;
        }
    
        @page {
          margin: 0;
        }
      </style>
    `);
    

    WindowPrt.document.write(printContent.innerHTML); // pass in the native html you got

    /**
     * you should probably use an observable instead of an interval for this, 
     * but this is just to illustrate a bug where the print would be fired before
     * all the content was written
     */
    const interval = setInterval(
      () => {
        if (document.readyState === 'complete') {
          WindowPrt.document.close();
          WindowPrt.focus();
          WindowPrt.print();
          clearInterval(interval);
        }
      },
      200);
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

}
